// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2DwAz","imageUploader":"EGiftCard_imageUploader__jrwa_"};